import { ispApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { TanstackTableSearchParamsAdapter } from '@itm/shared-frontend/lib/utils';

import {
  SchemeResponse,
  SchemeConfigurationShortResponse,
  SchemeConfigurationResponsePagedResponse,
  GetAltusSchemeStatusModel,
  GetAltusSchemeStatusResponse,
  GetPDPRegistrationResponseStatus,
} from 'src/types';

export const getSchemeListByCompanyId = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<SchemeResponse[]>(`/isp-internal/api/v1/schemes/assignedToCompany/${companyId}`, config);

export const getCompanyConfigurationSchemeListByCompanyId = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<SchemeConfigurationShortResponse[]>(
    `/isp-internal/api/v1/schemes/companies/${companyId}/configurations`,
    config,
  );

export type CompanyConfigurationSchemeListSearchParams = {
  companyId: string;
  pdpRegistrationStatus?: GetPDPRegistrationResponseStatus;
} & TanstackTableSearchParamsAdapter;

export const getCompanyConfigurationSchemeListSearch = (
  params: CompanyConfigurationSchemeListSearchParams,
  config: AxiosRequestConfig = {},
) =>
  ispApi.get<SchemeConfigurationResponsePagedResponse>('/isp-internal/api/v1/schemes/configurations/search', {
    ...config,
    params,
  });

export const getAltusSchemesStatuses = (data: GetAltusSchemeStatusModel, config: AxiosRequestConfig = {}) =>
  ispApi.post<GetAltusSchemeStatusResponse[]>('/isp-internal/api/v1/schemes/status', data, config);

export type SchemePDPPublishParams = {
  comment?: string;
};

export const enableSchemePDPPublish = (schemeId: string, params: SchemePDPPublishParams) =>
  ispApi.patch<void>(`/isp-internal/api/v1/schemes/${schemeId}/pdp`, undefined, { params });

export const disableSchemePDPPublish = (schemeId: string, params: SchemePDPPublishParams) =>
  ispApi.delete<void>(`/isp-internal/api/v1/schemes/${schemeId}/pdp`, { params });
